module.exports = __webpack_public_path__ + "static/media/pdf-header-1.41ca6aba.png";